<template>
	<div class="flip-countdown">
		<!-- 天、时、分、秒 四个数字块 -->
		<div class="countdown-digit" v-for="(digit, index) in digits" :key="index">
			<!-- 当前数字（下层，动画结束后显示） -->
			<div class="digit-current fontsize60" :class="{ 'flipping': digit.isFlipping }">
				<span>{{ digit.current }}</span>
			</div>
			<!-- 下一个数字（上层，动画过程中显示） -->
			<div class="digit-next fontsize60" :class="{ 'flipping': digit.isFlipping }">
				<span>{{ digit.next }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "FlipCountdown",
		props: {
			// 目标结束时间（毫秒时间戳，必填）
			endTime: {
				type: [Number, Date],
				default: () => new Date() // 默认值也可以是一个Date对象
			},
		},
		data() {
			return {
				digits: [{
						current: "00",
						next: "00",
						isFlipping: false
					}, // 天
					{
						current: "00",
						next: "00",
						isFlipping: false
					}, // 时
					{
						current: "00",
						next: "00",
						isFlipping: false
					}, // 分
					{
						current: "00",
						next: "00",
						isFlipping: false
					}, // 秒
				],
				timer: null, // 定时器ID，用于销毁时清除
			};
		},
		mounted() {
			this.startCountdown(); // 组件挂载后启动倒计时
		},
		beforeDestroy() {
			clearInterval(this.timer); // 组件销毁前清除定时器
		},
		methods: {
			startCountdown() {
				this.updateTime(); // 立即更新一次时间
				this.timer = setInterval(() => {
					// 每秒更新一次
					this.updateTime();
				}, 1000);
			},
			updateTime() {
				const now = Date.now();
				// console.log(now)
				// console.log(this.endTime)
				if (now >= this.endTime) {
					// 倒计时结束，显示全零并清除定时器
					this.resetToZero();
					clearInterval(this.timer);
					this.timer = null;
					console.log("倒计时结束")
					return;
				}

				// 计算剩余秒数
				let remaining = Math.floor((this.endTime - now) / 1000);

				// 分解为 天、时、分、秒（均补零为两位）
				const days = Math.floor(remaining / (24 * 3600));
				remaining %= 24 * 3600;

				const hours = Math.floor(remaining / 3600);
				remaining %= 3600;

				const minutes = Math.floor(remaining / 60);
				const seconds = remaining % 60;

				const times = [
					days.toString().padStart(2, "0"),
					hours.toString().padStart(2, "0"),
					minutes.toString().padStart(2, "0"),
					seconds.toString().padStart(2, "0"),
				];

				// 遍历“天、时、分、秒”，数字变化时触发翻转动画
				times.forEach((time, index) => {
					const digit = this.digits[index];
					if (digit.current !== time) {
						digit.isFlipping = true; // 标记为“正在翻转”
						digit.next = time; // 下一个要显示的数字
						// 动画结束后，同步“下一个数字”到“当前数字”，并重置翻转状态
						setTimeout(() => {
							digit.current = time;
							digit.isFlipping = false;
						}, 500); // 与CSS动画时长保持一致（0.5秒）
					}
				});
			},
			// 重置为全零显示
			resetToZero() {
				this.digits.forEach(digit => {
					if (digit.current !== "00") {
						digit.isFlipping = true;
						digit.next = "00";
						setTimeout(() => {
							digit.current = "00";
							digit.isFlipping = false;
						}, 500);
					}
				});
			}
		},
	};
</script>

<style scoped>
	/* 整体容器：黑色背景、横向排列 */
	.flip-countdown {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 50px;
		box-sizing: border-box;
	}

	/* 单个数字块（天/时/分/秒） */
	.countdown-digit {
	  width: 188px; /* 略微缩小宽度 */
	  height: 188px; /* 略微缩小高度 */
	  position: relative;
	  perspective: 500px; /* 增大透视值，减少变形感 */
	}
	
	/* 当前数字 + 下一个数字：绝对定位重叠 */
	.digit-current,
	.digit-next {
	  position: absolute;
	  top: 0;
	  left: 0;
	  width: 100%;
	  height: 100%;
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  font-weight: bold;
	  color: #fff; /* 白色数字 */
	  /* background-color: #333; */
	  border: 1px solid rgba(218, 210, 167, 0.27);
	  background: rgba(0, 0, 0, 0.15);
	  backdrop-filter: blur(15px);
	  border-radius: 5px;
	  overflow: hidden; /* 防止数字溢出 */
	  backface-visibility: hidden; /* 隐藏背面，减少视觉干扰 */
	  line-height: 0%;
	}
	
	/* 当前数字默认在上方 */
	.digit-current {
	  z-index: 1;
	}
	
	/* 下一个数字默认隐藏（动画时显示） */
	.digit-next {
	  z-index: 0;
	  opacity: 0;
	}
	
	/* 中间灰色横线：通过伪元素实现 */
	.digit-current::after,
	.digit-next::after {
	  content: "";
	  position: absolute;
	  top: 50%;
	  left: 0;
	  width: 100%;
	  height: 1px;
	  background-color: #666; /* 灰色横线 */
	  transform: translateY(-50%); /* 垂直居中 */
	}
	.digit-current span{
		margin-top: -10px;
	}
	
	/* 翻转动画：当前数字向上翻折 */
	.digit-current.flipping {
	  animation: flipCurrent 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) forwards;
	  transform-origin: bottom; /* 以上边缘为旋转中心 */
	}
	
	/* 翻转动画：下一个数字向上展开 */
	.digit-next.flipping {
	  animation: flipNext 0.5s cubic-bezier(0.645, 0.045, 0.355, 1) forwards;
	  transform-origin: top; /* 以下边缘为旋转中心 */
	  opacity: 1; /* 动画时显示 */
	  z-index: 2; /* 动画时覆盖当前数字 */
	}
	
	/* 当前数字的翻转动画 */
	@keyframes flipCurrent {
	  0% {
	    transform: rotateX(0deg) scale(1);
	  }
	  50% {
	    transform: rotateX(-45deg) scale(0.95); /* 翻转中间时略微缩小 */
	  }
	  100% {
	    transform: rotateX(-90deg) scale(0.9); /* 翻折结束时缩小更多 */
	  }
	}
	
	/* 下一个数字的翻转动画 */
	@keyframes flipNext {
	  0% {
	    transform: rotateX(90deg) scale(0.9); /* 初始时缩小 */
	  }
	  50% {
	    transform: rotateX(45deg) scale(0.95); /* 翻转中间时略微放大 */
	  }
	  100% {
	    transform: rotateX(0deg) scale(1); /* 展开后恢复正常大小 */
	  }
	}
</style>